module.exports = __webpack_public_path__ + "static/media/1019681.120b8d5f.jpg";